import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {environment} from '../environments/environment';
import {catchError} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RestApiService {
	API_URL = environment.apiUrl;
	constructor(private http: HttpClient) { }
	private formatErrors(error: any){ 
		return throwError(error);
	}
	// get http request
	get(path: string, params: HttpParams = new HttpParams): Observable<any> {
		//console.log('coming in get http..',`${environment.apiUrl}${path}`);
		const headers = new HttpHeaders({'Content-type': 'application/json'});
		return this.http.get(`${environment.apiUrl}${path}`,{headers, params})
		.pipe(catchError(this.formatErrors));
	}

	// post http request
	post(path: string, body: any): Observable<any> {
		const token = localStorage.getItem("token");
		const headers = new HttpHeaders({'Content-type': 'application/json', 'Authorization' : token ? "Bearer " + token : ''});
		return this.http.post(`${environment.apiUrl}${path}`, JSON.stringify(body), {headers})
		.pipe(catchError(this.formatErrors));
	}

	// put http request
	put(path: string, body: {}): Observable<any> {
		const headers = new HttpHeaders({'Content-type': 'application/json'});
		return this.http.put(`${environment.apiUrl}${path}`, JSON.stringify(body), {headers})
		.pipe(catchError(this.formatErrors));
	}

	// delete http request
	delete(path: string, params: HttpParams): Observable<any> {
		const headers = new HttpHeaders({'Content-type': 'application/json'});
		return this.http.delete(`${environment.apiUrl}${path}`, {params, headers})
		.pipe(catchError(this.formatErrors));
	}

	// postWithImages(path: string, body: any): Observable<ny>{
	//   const headers = new HttpHeaders({'Content-type': 'application/json'});
		
	// }

	public postDirect(path, body) {
		const headers = new HttpHeaders().set("Authorization", "Bearer " + localStorage.getItem("token"));
		return this.http.post(`${environment.apiUrl}${path}`, body, {headers})
		.pipe(catchError(this.formatErrors));
	}
}
